/*
  To add a font :
  1. add it here, replace spaces with dashes ('-')
  2. make sure the font is mentionned in the google fonts list from every Q3 page : view.ejs, editor.ejs, and demo.html in public/
  3. modify public/q3.css so the font is used on related text
  4. modify Viewer/TextEditor/Fonts.css so the editor displays the font properly in the list.
*/

export default [
    "Gilroy Regular",
    "Gilroy Medium",
    "Gilroy SemiBold",
    "Gilroy Bold",
    "Lato",
    "Akshar",
    "Mukta",
    "Bitter",
    "Barlow Condensed",
    "Boogaloo",
    "Jockey One",
    "Lobster",
    "Montserrat",
    "Noticia Text",
    "Orbitron",
    "Oswald",
    "Raleway",
    "Ranga",
    "Roboto",
    "Roboto Slab",
    "Squada One",
    "Titillium Web",
    "Ubuntu",
    "Vollkorn",
    "Amiko",
    "Amita",
    "Anek Devanagari",
    "Arya",
    "Asar",
    "Bakbak One",
    "Baloo 2",
    "Biryani",
    "Cambay",
    "Dekko",
    "Eczar",
    "Glegoo",
    "Gotu",
    "Halant",
    "Hind",
    "IBM Plex Sans Devanagari",
    "Inknut Antiqua",
    "Jaldi",
    "Kadwa",
    "Kalam",
    "Karma",
    "Khand",
    "Khula",
    "Kurale",
    "Laila",
    "Martel",
    "Martel Sans",
    "Modak",
    "Noto Sans",
    "Noto Sans Devanagari",
    "Noto Serif Devanagari",
    "Palanquin",
    "Palanquin Dark",
    "Poppins",
    "Pragati Narrow",
    "Rajdhani",
    "Rhodium Libre",
    "Rozha One",
    "Sahitya",
    "Sarala",
    "Sarpanch",
    "Sumana",
    "Sura",
    "Teko",
    "Tillana",
    "Tiro Devanagari Hindi",
    "Tiro Devanagari Marathi",
    "Tiro Devanagari Sanskrit",
    "Vesper Libre",
    "Yantramanav",
    "Yatra One"
]